<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import type { CtaLoadingCopy } from '../types/site'
import CtaButton from './CtaButton.vue'

defineProps<{
  label: string
  href: string
  loading?: CtaLoadingCopy
}>()

const visible = ref(false)
let heroElement: HTMLElement | null = null
let animationFrame = 0

const SHOW_AT_HERO_BOTTOM = 56
const HIDE_AT_HERO_BOTTOM = 180

const syncWithScroll = () => {
  animationFrame = 0
  if (!heroElement) return

  const heroBottom = heroElement.getBoundingClientRect().bottom
  if (visible.value) {
    if (heroBottom >= HIDE_AT_HERO_BOTTOM) visible.value = false
  } else if (heroBottom <= SHOW_AT_HERO_BOTTOM) {
    visible.value = true
  }
}

const scheduleSync = () => {
  if (animationFrame) return
  animationFrame = window.requestAnimationFrame(syncWithScroll)
}

onMounted(() => {
  heroElement = document.querySelector<HTMLElement>('.hero-section')
  if (!heroElement) return

  scheduleSync()
  window.addEventListener('scroll', scheduleSync, { passive: true })
  window.addEventListener('resize', scheduleSync)
  window.visualViewport?.addEventListener('resize', scheduleSync)
})

onBeforeUnmount(() => {
  if (animationFrame) window.cancelAnimationFrame(animationFrame)
  window.removeEventListener('scroll', scheduleSync)
  window.removeEventListener('resize', scheduleSync)
  window.visualViewport?.removeEventListener('resize', scheduleSync)
})
</script>

<template>
  <Transition name="floating-play">
    <CtaButton
      track="floating-cta"
      v-show="visible"
      class="floating-play-cta"
      :label="label"
      :href="href"
      :loading="loading"
    />
  </Transition>
</template>
